import { render, staticRenderFns } from "./PlayerDailyPointHistory.vue?vue&type=template&id=5e04bddf&scoped=true&"
import script from "./PlayerDailyPointHistory.vue?vue&type=script&lang=js&"
export * from "./PlayerDailyPointHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e04bddf",
  null
  
)

export default component.exports